<template>
    <div v-if="myManagers?.length" class="my-manager">
        <div class="my-manager__title">
            Ваши {{ getTitle }}
        </div>
        <div class="my-manager__list" :class="{'my-manager__list--hide': openManagers }">
            <div class="my-manager__item" v-for="manager in myManagers" :key="manager.id">
                <div class="my-manager__name">{{ manager.name }} {{ manager.lastName }} <span v-if="manager.isOnline">Онлайн</span></div>
                <div v-if="!manager.isOnline" class="my-manager__lastseen">Был(-а) в сети в {{ manager.lastActivityDate }}</div>
                <a v-for="(phone,index) in manager.phones" :key="index" :href="`tel:${phone}`" class="my-manager__phone">+{{ phone }}</a>
                <a v-if="manager.email" :href="`mailto:${manager.email}`" class="my-manager__email">{{ manager.email }}</a>
                <button class="my-manager__categories" @click="openProductCategoriesPopup(manager.productGroups)">Товарные категории</button>
            </div>
        </div>
        <div v-if="myManagers.length > 2" class="my-manager__more" @click="openManagers = !openManagers">{{ openManagers ? 'Показать всех' : 'Скрыть' }}</div>
        <PageLoader v-if="isLoading" :type="'absolute'"/>
    </div>
    <teleport to="body">
        <transition name="modal" >
            <ProductCategoriesPopup v-if="ShowProductCategoriesPopup" @close="ShowProductCategoriesPopup = false" :data="this.managerCategories"/>
        </transition>
    </teleport>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import ProductCategoriesPopup from "@/components/sections/Tenders/TenderInner/ProductCategoriesPopup.vue";
import PageLoader from "@/components/base/utils/PageLoader.vue";


export default {
	name: "MyManager",
    components: {ProductCategoriesPopup, PageLoader},
	props: {
		type: {
			type: String,
			default: 'managers'
		}
	},
    data() {
        return {
            openManagers: true,
            managerCategories: [],
            ShowProductCategoriesPopup: false,
			myManagers: [],
        }
    },
    async created() {
        // await this.requestMyManager()
		if (this.type === 'category-admins') {
			if (this.checkUserRole('manager')) {
				const response = await this.requestManagerCategoryAdmins();
				if (response.data.length) this.myManagers = response.data;
			} else if (this.checkUserRole('category_manager')) {
				const response = await this.requestCategoryAdmins();
				if (response.data.length) this.myManagers = response.data;
			}
		} else if (this.type === 'category-managers') {
			if (this.checkUserRole('manager')) {
				const response = await this.requestManagerCategoryManagers();
				if (response.data.length) this.myManagers = response.data;
			}
		} else if (this.type === 'managers') {
            console.log('managers')
			if (this.checkUserRole('supplier')) {
				const response = await this.requestMyManagers();
				if (response.data.length) this.myManagers = response.data;
			}
		}
        this.openManagers = this.myManagers.length > 2
    },
    methods: {
        openProductCategoriesPopup(categories) {
            this.managerCategories = categories
            this.ShowProductCategoriesPopup = true
        },
        ...mapActions({
			requestMyManagers: 'suppliers/requestMyManager',
			requestCategoryAdmins: 'categoryManagers/requestCategoryAdmins',
			requestManagerCategoryAdmins: 'managers/requestCategoryAdmins',
			requestManagerCategoryManagers: 'managers/requestCategoryManagers',
		})
    },
    computed: {
		getTitle() {
			if (this.type === 'category-managers') {
				return'категорийные менеджеры'
			}
			else if (this.type === 'category-admins') {
				return'управляющие категориями'
			}
			return 'менеджеры'
		},
        ...mapGetters({
			checkUserRole: 'user/checkUserRole',
            isLoading: 'isLoading',
        })
    }
}
</script>

